import { Listener } from '@/types';

export function createListeners(element: Element, listeners: Listener[]) {
  listeners.forEach((listener) => {
    element.addEventListener(listener.event, listener.callback);
  });
}

export function removeListeners(element: Element, listeners: Listener[]) {
  listeners.forEach((listener) => {
    element.removeEventListener(listener.event, listener.callback);
  });
}
